//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  Signal,
  signal,
  WritableSignal,
} from "@angular/core";

//local imports
import { PresenterType } from "@app/shared";
import { CatalogMenuModel } from "@app/catalog";

@PresenterType({
  model: CatalogMenuModel,
})
@Component({
  selector: "catalog-menu",
  templateUrl: "./catalog-menu.component.html",
  styleUrl: "./catalog-menu.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CatalogMenuComponent {
  public data: WritableSignal<CatalogMenuModel> = signal<CatalogMenuModel>(null);
}
